import { BaseApi } from '@/helpers/base-api'

export default class AnnouncementsApi extends BaseApi {
  constructor () {
    super('/api/v1/announcements')
    this.errorMessage = 'There was an issue when trying to fetch the announcements. If this error persists, please contact our support.'
  }

  public getAllAnnouncements = (): Promise<AnnouncementDto[]> => this.instance.get('');

  public createAnnouncementException = (announcementId: string): Promise<JSON> => this.instance.post(`/exceptions/${announcementId}`);

}